<template>
  <div :class="$style.loadingBox">
    <Loading :class="$style.loading" />
    <img src="./assets/light_icon.png" :class="$style.light" />
    <div :class="$style.tips">{{ tips }}</div>
  </div>
</template>
<script>
import i18n from '@/i18n'
import Loading from '@/components/Loading'
import EventBus from '@/utils/EventBus'
export default {
  name: 'LoadingBox',
  components: {
    Loading
  },
  data() {
    return {
      tips: i18n.t('46680e2228')
    }
  },
  created() {
    EventBus.$on('updateProcessing', (percent) => {
      this.tips = i18n.t('3d86d5e41b', [percent])
    })
  }
}
</script>
<style lang="scss" module>
.loadingBox {
  width: 480px;
  height: 260px;
  margin: auto;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  user-select: none;
  text-align: center;
}

.loading {
  margin: 80px auto 0;
}

.light {
  width: 24px;
  height: 24px;
  margin-top: 24px;
}

.tips {
  margin: 9px 30px 30px;
  color: #000;
  font-size: 14px;
  line-break: 19px;
}
</style>
